import React from 'react';
import { bonuses } from '../data/kit';
import { pricing } from '../data/pricing';
export function BonusesSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-24" data-mp="gwx4d05qj1co">
      <div className="max-w-3xl mx-auto" data-id="element-25" data-mp="vsmlajw2coaj">
        <div className="text-center mb-12" data-id="element-26" data-mp="vtnvkm5996r7">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-27" data-mp="qtt68n14op89">
            3 Bonos Exclusivos
          </h2>
          <p className="text-brand-gray" data-id="element-28" data-mp="14t2p5ugpxxfx">
            Valorados en{' '}
            <span className="font-bold text-brand-terracottaText line-through" data-id="element-29" data-mp="zuhlfl29cvmq">
              {pricing.bonusesValue}
            </span>{' '}
            — hoy, <strong className="text-brand-text" data-id="element-30" data-mp="1ei2mzajhimsj">GRATIS</strong>
          </p>
        </div>

        <ul className="space-y-5" data-id="element-31" data-mp="19lc6wn7ojr74">
          {bonuses.map((bonus, i) => <li key={bonus.title} className="bg-white rounded-2xl p-5 md:p-6 flex items-center gap-4 md:gap-6 shadow-sm border border-brand-creamDark/50" data-id="element-32" data-mp="1njkc1ievdytd" data-mpi={i}>
              <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-greenDark text-white flex items-center justify-center font-bold shrink-0 text-sm md:text-base" data-id="element-33" data-mp="3pqlkp3p7rc8x">
                {i + 1}
              </span>
              <img src={bonus.image} alt={bonus.alt} loading="lazy" className="w-20 h-20 md:w-28 md:h-28 rounded-xl object-cover shrink-0 border border-brand-creamDark/60" data-id="element-34" data-mp="2lclzx9f33ns" />
              <div className="flex-1" data-id="element-35" data-mp="chz8eqhe62rx">
                <h3 className="font-bold text-brand-text text-base md:text-lg mb-1" data-id="element-36" data-mp="gklsu6bqglf3">
                  {bonus.title}
                </h3>
                <p className="text-brand-gray text-xs md:text-sm leading-snug mb-2" data-id="element-37" data-mp="lcvqk8j3aprx">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-38" data-mp="va9x9gf7o071">
                  <span className="text-brand-terracottaText line-through font-medium" data-id="element-39" data-mp="v86wq2gfmoo2">
                    {pricing.bonusUnitValue}
                  </span>
                  <span className="text-brand-greenDeep font-bold" data-id="element-40" data-mp="ama9dz3ce6bc">GRATIS</span>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}